import { useEffect } from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import mixpanel from 'mixpanel-browser';
import {
  LOGIN_SEO_DESCRIPTION,
  LOGO_NAME,
  SOURCE_STORAGE_KEY,
  TERMS_OF_SERVICE_LINK,
} from '@/constants';
import styles from '@/styles/Onboarding.module.css';
import { EVENT } from '@/analytics';
import Image from 'next/image';
import { Text } from '@typedream/ui';
import LoginSignupForm from '@/components/LoginSignupForm';
import Link from 'next/link';
import classNames from 'classnames';
// import MaintenanceBanner from '../components/MaintenanceBanner';

const Seo = dynamic(() => import('@/head/Seo'));
const SignupSection = dynamic(() => import('@/components/SignupSection'));
const SignupRightSection = dynamic(() => import('@/components/SignupRightSection'));

function SignUp() {
  const router = useRouter();

  useEffect(() => {
    const referrer = router.query.via;
    localStorage?.setItem(
      SOURCE_STORAGE_KEY,
      referrer ? `rewardful-${referrer as string}` : String(router?.query?.utm_source)
    );
  }, [router?.query]);

  useEffect(() => {
    mixpanel.track(EVENT.VIEW_SIGNUP_PAGE);
  }, []);

  return (
    <>
      <div className="w-full h-full md:hidden">
        <Image
          src="/images/new_logo_svg.svg"
          alt=""
          width={104.61}
          height={20}
          className="absolute top-[65px] left-[23px]"
        />
        <div className="flex w-4/5 px-4 flex-col items-start gap-16 mt-[150px]">
          <div className="f-399 flex p-0 flex-col items-start gap-[9px] self-stretch">
            <Text size="2xl" className="max-w-[305px]" weight="semibold">
              Sign up and start building
            </Text>
            <Text size="xs" className="w-full text-secondary" weight="medium">
              By signing up, you agree to our{' '}
              <a href={TERMS_OF_SERVICE_LINK} className="text-secondary underline">
                Terms of Service
              </a>{' '}
              and Privacy Policy
            </Text>
          </div>
        </div>

        <div className="w-full px-4 mt-16">
          <LoginSignupForm login={false} redirect />
          <Text className="my-3" size="sm" weight="medium">
            Already have an account?{' '}
            <Link
              href={{
                pathname: '/login',
                query: router.query,
              }}
            >
              Log in
            </Link>
          </Text>
        </div>
      </div>
      <div className={classNames(styles.container, '!hidden md:!flex')}>
        {/* <MaintenanceBanner /> */}
        <Seo title={LOGO_NAME} desc={LOGIN_SEO_DESCRIPTION} />
        <div className={styles.signupContainer}>
          <div className={styles.leftContainer}>
            <SignupSection bypass={false} />
          </div>
          <div className={styles.rightContainer}>
            <SignupRightSection />
          </div>
        </div>
      </div>
    </>
  );
}

SignUp.theme = 'light';
export default SignUp;
